export const getInitiatState = (ctrl) => {
  const initialState = {
    paying: false,

    finalAmount: 0,
    storeCardInfo: false,
    elementContent: {},
    showCheckoutForm: false,
    showUserAmountForm: false,

    selectedSubscriptionProduct: '',
    selectedSubscriptionProductDetails: {},
    loadingSubscriptionProducts: false,
    loadingSubscriptionProductsError: false,
    productError: '',

    disableInputs: false,

    userAmount: ctrl.props.amount > 0 ? ctrl.props.amount : 0,
    lineItem: {
      amount: 0,
      currency: '',
      name: '',
      description: '',
    },
    formData: {
      name: '',
      email: '',
      line1: '',
      city: '',
      state: '',
      postal_code: '',
      country: '',
    },
  };
  return initialState;
};

export const actionTypes = {
  OTHERS: 'OTHERS',
  GROUPED: 'GROUPED',
};

export const stripeStateReducer = (state, { type, payload }) => {
  switch (type) {
    case actionTypes.OTHERS:
      return { ...state, ...payload };
    case actionTypes.GROUPED:
      return { ...state, [payload.ref]: { ...state[payload.ref], ...payload.main } };
    default:
      throw new Error(`Unhandled action type: ${type}`);
    // return state;
  }
};

export default { getInitiatState };
